import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { PORTFOLIO as TID } from "@/constants/testIds";

const Lightbox = ({ items, index, onClose, onPrev, onNext }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNext();
      if (e.key === "ArrowLeft") onPrev();
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose, onPrev, onNext]);

  if (index === null || index === undefined || !items[index]) return null;
  const item = items[index];

  return (
    <div
      data-testid={TID.lightbox}
      className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center"
      onContextMenu={(e) => e.preventDefault()}
    >
      <button
        data-testid={TID.lightboxClose}
        onClick={onClose}
        className="absolute top-6 right-6 text-white/80 hover:text-gold transition-colors z-10"
        aria-label="Sluiten"
      >
        <X size={28} />
      </button>

      <button
        data-testid={TID.lightboxPrev}
        onClick={onPrev}
        className="absolute left-4 md:left-8 text-white/80 hover:text-gold transition-colors z-10"
        aria-label="Vorige"
      >
        <ChevronLeft size={40} />
      </button>

      <button
        data-testid={TID.lightboxNext}
        onClick={onNext}
        className="absolute right-4 md:right-8 text-white/80 hover:text-gold transition-colors z-10"
        aria-label="Volgende"
      >
        <ChevronRight size={40} />
      </button>

      <img
        src={item.src}
        alt="Portfolio"
        className="max-h-[90vh] max-w-[92vw] object-contain select-none"
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
      />

      <div className="absolute bottom-6 left-0 right-0 text-center text-white/50 text-xs uppercase tracking-[0.3em]">
        {index + 1} / {items.length}
      </div>
    </div>
  );
};

export default Lightbox;
